import {
  CompanyCreationDocumentStatus,
  CompanyCreationDocumentType,
} from '__generated__/GQL';

import { VerificationModuleData } from '../machine/model';
import { VerificationStatus } from './steps/types';

export const getCreationDocumentStatus = (
  documentType: CompanyCreationDocumentType,
  { isSasuCreation, verificationData }: VerificationModuleData,
): VerificationStatus => {
  const document =
    verificationData.viewer.company.companyCreationDocuments.find(
      (doc) => doc.type === documentType,
    );

  const { status: docStatus } = document ?? {};
  if (
    !isSasuCreation ||
    (documentType ===
      CompanyCreationDocumentType.CompanyCertificateOfResidence &&
      !document)
  ) {
    return VerificationStatus.Irrelevant;
  }

  if (docStatus === CompanyCreationDocumentStatus.Refused) {
    return VerificationStatus.Invalid;
  }

  if (docStatus === CompanyCreationDocumentStatus.Missing) {
    return VerificationStatus.ToDo;
  }

  if (docStatus === CompanyCreationDocumentStatus.Validated) {
    return VerificationStatus.Validated;
  }

  return VerificationStatus.Completed;
};
